module.exports = __webpack_public_path__ + "img/whiskey.12768279.png";